var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useAppSelector } from "@/hooks/store";
import { Slot, SlotDirection } from "@/utils/types/layout";
import { useSlotVisibility } from "@/hooks/layout";
import AddWidgetControl from "@/components/layout/edit/addWidget";
import WidgetGrid from "./widgetGrid";
import { useFilteredWidgets } from "@/utils/themes/hooks";
export default function MenuWest() {
    var menuWestVisible = useSlotVisibility().menuWestVisible;
    var filteredWidgets = useFilteredWidgets(Slot.MENU_WEST);
    var isEditingLayout = useAppSelector(function (state) { return state.layout.editingLayout; });
    var areaVisible = (menuWestVisible && filteredWidgets.length > 0) || isEditingLayout;
    if (areaVisible) {
        if (filteredWidgets.length === 0 && !isEditingLayout) {
            return _jsx(_Fragment, {});
        }
        return (_jsxs("aside", __assign({ className: "  ".concat(isEditingLayout && "border-[2px] border-[var(--colors-widget-border)]", " flex-none flex flex-col w-[var(--sizes-vertical-menu-expanded-width)]\n        bg-[var(--colors-menu-west-bg)] mt-[var(--margin-mt-menu-west)] mr-[var(--margin-mr-menu-west)]\n        mb-[var(--margin-mb-menu-west)] ml-[var(--margin-ml-menu-west)] menu-west direction-vertical\n        scroll-contain overflow-hidden border-r-[var(--colors-layout-separator)]") }, { children: [_jsx("div", __assign({ className: "relative w-full h-full overflow-hidden widgets-container scroll-elements" }, { children: _jsx(WidgetGrid, { direction: SlotDirection.VERTICAL, filteredWidgets: filteredWidgets, isEditingLayout: isEditingLayout }) })), isEditingLayout && _jsx(AddWidgetControl, { to: Slot.MENU_WEST })] })));
    }
    return _jsx(_Fragment, {});
}
